<template>
  <DatePicker 
    ref="datePickerRef"
    v-model="choosedDate"
    class="datePicker"
    :pt="{
      timepicker: 'hidden'
    }"
    show-icon 
    fluid 
    icon-display="input"
    :disabled="props.data.disabled"
    :placeholder="props.data.placeholder"
    :min-date="props.data.min"
    :enable-time-picker="props.data.additionalOptions.showTime ? true : false"
    :show-time="props.data.additionalOptions.showTime ? true : false"
    :step-minute="60"
    hour-format="12"
    selection-mode="multiple"
    :show-button-bar="false"
    date-format="M dd, yy"
    :format="date => {
      let returnDate = ''
      if (choosedDate[0]) {
        const currentDate = new Date(choosedDate[0]);

        returnDate = `${$t(`monthsYear.${currentDate.getMonth()}`).substring(0, 3)} ${currentDate.getDate()}, ${currentDate.getFullYear()}`

        if (props.data.additionalOptions.showTime) {
          returnDate += ` ${currentDate.getHours() % 12}:${currentDate.getMinutes() + '0'} ${currentDate.getHours() >= 12 ? 'PM' : 'AM'}`
        }
      }

      return returnDate
    }"
    :clearable="props.data.additionalOptions.clearable ? props.data.additionalOptions.clearable : false"
    :is-24="false"
    @date-select="(e) => { 
      choosedDate = [e]
      
      emit('returnData', $dayjs(choosedDate[0]).tz('America/Chicago').format().toString())
    }"
  >
    <template #inputicon>
      <i
        class="icon icon-calendar"
      />
    </template>

    <template #footer>
      <div
        v-if="props.data.additionalOptions.showTime"
        class="relative w-full pt-4 pb-2"
      >
        <select
          class="appearance-none w-full h-[48px] px-4 border rounded-md text-[14px]"
          :disabled="!choosedDate[0]"
          @change="($event) => {
            const newDate = new Date(choosedDate[0])
            newDate.setHours(+$event.target.value)
            newDate.setMinutes(0)
            choosedDate = [newDate]
          }"
        >
          <option
            v-for="h in hoursArray"
            :key="h.code"
            :value="h.code"
            :selected="choosedDate[0]?.getHours() * 1 === h.code * 1 || (!choosedDate[0]?.getHours() && h.code === '')"
            :disabled="h.disabled"
          >
            {{ h.selected }}
            {{ h.name }}
          </option>
        </select>

        <div class="absolute inset-y-0 right-3 flex items-center pointer-events-none">
          <span class="icon icon-down-arrow"></span>
        </div>
      </div>
        
      <div class="flex justify-between space-x-2 border-t pt-3 mt-2">
        <div class="flex justify-end space-x-2">
          <Button
            :label="$t('clear')"
            size="small"
            variant="outlined"
            @click="() => { 
              datePickerRef.overlayVisible = false
              choosedDate = []
              emit('returnData', '')
            }"
          />
        </div>
        <div class="flex justify-end space-x-2">
          <Button
            :label="$t('reset')"
            size="small"
            variant="outlined"
            @click="() => { 
              datePickerRef.overlayVisible = false
              if (defaultDate) {
                choosedDate = [new Date(defaultDate)]
              } else {
                choosedDate = defaultDate
              }

              emit('returnData', choosedDate && choosedDate[0] ? $dayjs(choosedDate[0]).tz('America/Chicago').format().toString() : '')
            }"
          />

          <Button
            :label="$t('submit')"
            size="small"
            @click="() => { 
              datePickerRef.overlayVisible = false
            }"
          />
        </div>
      </div>
    </template>
  </DatePicker>
</template>

<script setup>
const { $i18n: i18n } = useNuxtApp()
const $dayjs = useDayjs()

const datePickerRef = ref()
const defaultDate = ref()

/*
* Props
*/
const props = defineProps({
  data: {
    type: [Object],
    default: null
  }
})

const choosedDate = ref([])

if (props.data.formData[props.data.name]) {
  choosedDate.value.push(new Date(props.data.formData[props.data.name]))
}
defaultDate.value = props.data.formData[props.data.name] ? JSON.parse(JSON.stringify(props.data.formData[props.data.name])) : null

/**
* Emits
*/
const emit = defineEmits(['returnData'])

/**
* Date-Time Field
*/
const hoursArray = computed(() => {
  const now = new Date()

  const arr = [{ name: i18n?.t('pleaseSelectTime'), code: '', disabled: true }]
  if (choosedDate.value[0]) {
    const selectedDate = choosedDate.value[0] ? new Date(choosedDate.value[0]) : false

    let minHour = 1
    if (selectedDate) {
      if (selectedDate.getFullYear() === now.getFullYear() &&
      selectedDate.getMonth() === now.getMonth() &&
      selectedDate.getDate() === now.getDate()) {
        minHour = now.getHours() + 1
      }
    }

    for (let i = 1; i < 24; i++) {
      if (i >= minHour) {
        if (i <= 12) {
          arr.push({ name: `${i}:00 AM`, code: `${i}` })
        } else {
          arr.push({ name: `${i - 12}:00 PM`, code: `${i}` })
        }
      }
    }
  }

  return arr
})
</script>

<style lang="scss" scoped> 
</style>
